import ControlViewModel from '@/ViewModels/ControlViewModel';
import ComponentManager from '@/Management/ComponentManager';
import ResourceManager from '@/Management/ResourceManager';
import LabelViewModel from '@/ViewModels/Controls/LabelViewModel';

export default class TextBoxViewModel extends ControlViewModel {

    /**
    * Der Wert der TextBox
    */
    public value: KnockoutObservable<string>;

    /**
    * Der Name der TextBox
    */
    public name: KnockoutObservable<string>;

    /**
    * Ein Handler, der aufgerufen wird, wenn sich der Wert verändert
    */
    public onChange: (value: string) => void;

    /**
    * Ein Handler, der aufgerufen wird, wenn der Benutzer eine Taste drückt
    */
    public onKeyDown: (keyCode: number) => void;

    /**
    * Ein Handler, der aufgerufen wird, wenn der Benutzer eine Taste loslässt
    */
    public onKeyUp: (keyCode: number) => void;

    /**
    * Das ViewModel für die Einheit des Wertes
    */
    public label: LabelViewModel;

    /**
    * Ein Handler, der aufgerufen wird, wenn der benutzer Enter drückt
    */
    public onSubmit: (value: string) => void;

    /**
    * Gibt die maximale Länge des Textes an
    */
    public maxLength: number; 

    /**
    * Gibt die Sprache des eingegebenen Textes an
    */
    public language: KnockoutObservable<string>;

    /**
    * Gibt den Platzhalter an (placeholder-Attribut)
    */
    public placeholder: KnockoutObservable<string>;

    /**
    * Der ARIA-Label-Text für das Eingabefeld
    */
    public ariaLabel: string;

    public constructor(protected params: any) {  
        super(params); 
        this.value = this.observableOrDefault(params.value, '');
        this.name = this.observableOrDefault(params.name, );
        this.onChange = this.handlerOrDefault(params.onChange);
        this.onKeyDown = this.handlerOrDefault(params.onKeyDown);
        this.onKeyUp = this.handlerOrDefault(params.onKeyUp);
        this.label = this.paramOrDefault(params.label, null);
        this.onSubmit = this.paramOrDefault(params.onSubmit);
        this.maxLength = this.paramOrDefault(params.maxLength, -1);
        this.language = this.observableOrDefault(params.language, (ResourceManager.getInstance().language as any).value());
        this.placeholder = this.observableOrDefault(params.placeholder, '');
        this.ariaLabel = this.paramOrDefault(params.ariaLabel, '');

        ControlViewModel.checkProperties(this, params);
    }

    /**
     * @override
     * @inheritdoc 
     */
    public resetValue() {
        this.value(null);
    }
}

ComponentManager.setViewModel('TextBoxViewModel', TextBoxViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');